export const SUPPORTED_LANGUAGES = [
  'ru',
  'en',
  'uk',
  'de',
  'it',
  'fr',
  'zh',
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const isSupportedLanguage = (
  value: string,
): value is SupportedLanguage =>
  SUPPORTED_LANGUAGES.some(language => language === value);
